<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <div class="rappider-component navigation-bar-1">
    <!-- Component: Navigation Bar 1 -->
    <rappider-navigation-bar
      [menu]="navigationBar_1.menu"
      [isMenuVisible]="navigationBar_1.isMenuVisible"
      [brandRouteUrl]="navigationBar_1.brandRouteUrl"
      [brandImage]="navigationBar_1.brandImage"
      [brandText]="navigationBar_1.brandText"
      [isBrandVisible]="navigationBar_1.isBrandVisible"
      [buttons]="navigationBar_1.buttons"
      [dropdowns]="navigationBar_1.dropdowns"
      [togglerIcon]="navigationBar_1.togglerIcon"
      [isSearchable]="navigationBar_1.isSearchable"
      [searchArea]="navigationBar_1.searchArea"
      [cart]="navigationBar_1.cart"
      [drawer]="navigationBar_1.drawer"
      [isCartVisible]="navigationBar_1.isCartVisible"
      [responsiveMenuMode]="navigationBar_1.responsiveMenuMode"
    >
    </rappider-navigation-bar>
  </div>

  <div>
    <router-outlet></router-outlet>
  </div>

  <!-- Container: Container 5 -->
  <div class="rappider-container container-5 col-12">
    <div class="rappider-component button-list-21">
      <!-- Component: Button List 21 -->
      <rappider-button-list
        [buttons]="buttonList_21.buttons"
        [direction]="buttonList_21.direction"
        [gap]="buttonList_21.gap"
      >
      </rappider-button-list>
    </div>

    <div class="rappider-component button-list-22">
      <!-- Component: Button List 22 -->
      <rappider-button-list
        [buttons]="buttonList_22.buttons"
        [direction]="buttonList_22.direction"
        [gap]="buttonList_22.gap"
      >
      </rappider-button-list>
    </div>

    <div class="rappider-component paragraph-19">
      <!-- Component: Paragraph 19 -->
      <rappider-paragraph
        [content]="paragraph_19.content"
        [colorSettings]="paragraph_19.colorSettings"
        [typography]="paragraph_19.typography"
      >
      </rappider-paragraph>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->
